export default "__VITE_ASSET__BAduPEZy__"